import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { AuthProvider } from './auth/useAuth'
import { I18nProvider } from './i18n/useI18n'
import { YearProvider } from './year/useYear'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('Element #root introuvable dans index.html')

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <AuthProvider>
        <YearProvider>
          <App />
        </YearProvider>
      </AuthProvider>
    </I18nProvider>
  </StrictMode>,
)
